import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.css';
import { TextRegular } from 'UiKit/typography';
import { WarningIcon } from 'Asset/icon';

const BadgeNoActiveHost = () => {
  const { t } = useTranslation('schedule');
  return (
    <Box className={styles['badge__container']}>
      <WarningIcon size="14px" color="var(--color-error50)" />
      <TextRegular className={styles['badge__text--no-active']}>{t('noActiveHostBadgeText')}</TextRegular>
    </Box>
  );
};

export default BadgeNoActiveHost;
